module.exports = __webpack_public_path__ + "static/media/favicon.2de2839a.ico";